import React from 'react'
import { css } from 'glamor'
import { propMerge } from 'glamor/react'
import { h4Styles } from '../../constants/textStyles'

const styles = css(h4Styles)

const H4 = ({ children, ...otherProps }) => {
	return <h4 {...propMerge(styles, otherProps)}>{children}</h4>
}

export default H4